import { api, TCustomAxiosResponse } from '..';
import { TNotification } from '@/types/Notification.types';

const root = 'v1/notifications';

const endpoints = {
  notifications: `${root}`,
  unreadCount: `${root}/count`,
  markAllRead: `${root}/mark-all-read`,
  markMultipleRead: `${root}/mark-multiple-read`,
  notifyOrgAdminsAboutMissingPeerSupport: `${root}/report-missing-peer-support`,
  sendScreenerReminder: `${root}/send-screener-reminder`,
};

export const getNotifications = async (page = 1, limit = 10): Promise<TCustomAxiosResponse<TNotification[]>> => {
  const { data } = await api.get<TCustomAxiosResponse<TNotification[]>>(endpoints.notifications, {
    params: { page, limit },
  });

  return data;
};

export const getUnreadNotificationsCount = async (): Promise<number> => {
  const { data } = await api.get<{ count: number }>(endpoints.unreadCount);

  return data.count;
};

export const getNotificationById = async (notificationId: string): Promise<TNotification[]> => {
  const { data } = await api.get<TCustomAxiosResponse<TNotification[]>>(`${endpoints.notifications}/${notificationId}`);
  const notification = data.data;

  return notification;
};

export const markAllNotificationsAsRead = async (): Promise<string> => {
  const { data } = await api.post(endpoints.markAllRead);

  const result = data.data;

  return result;
};

export const sendScreenerReminder = async (): Promise<string> => {
  const { data } = await api.post(endpoints.sendScreenerReminder, {
    channels: ['HTTP', 'EMAIL'],
  });

  return data;
};

export const toggleNotificationReadStatus = async (notificationId: string, isRead: boolean): Promise<string> => {
  const { data } = await api.patch(`${endpoints.notifications}/${notificationId}/read-status`, { isRead });

  const result = data.data;

  return result;
};

export const toggleMultipleNotificationsReadStatus = async (notificationIds: string[]): Promise<string> => {
  const { data } = await api.post(`${endpoints.markMultipleRead}`, { notificationIds });

  const result = data.data;

  return result;
};

export const notifyOrgAdminsAboutMissingPeerSupport = async (): Promise<string> => {
  const { data } = await api.post(endpoints.notifyOrgAdminsAboutMissingPeerSupport);

  return data;
};
